import { inject, Pipe, PipeTransform } from '@angular/core';
import { FeatureFlags, FeatureFlagService } from '@rma/dashboard/generic/util/feature-flags';
import { SyndicationChannel } from '../domain/syndication-channels.model';

@Pipe({
  name: 'subscriptionTierChannels',
  standalone: true,
})
export class SubscriptionTierChannelsPipe implements PipeTransform {
  private readonly features = inject(FeatureFlagService);
  transform(tierName: string, isFinance = false): SyndicationChannel[] {
    const tier = isFinance ? `finance-${tierName}` : tierName;
    const tiers = this.features.getFeature<Record<string, SyndicationChannel[]>>(FeatureFlags.SubscriptionTierChannels, {});
    return tiers[tier.toLocaleLowerCase()] ?? [];
  }
}
